var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user_box"},[_c('userMenu',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMenu),expression:"showMenu"}]}),_c('div',{staticClass:"user_con"},[_c('keep-alive',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }